import { actionCreator, asyncActionCreators } from '../../utils/actions';

export const fetchInfoEvents = asyncActionCreators('FETCH_INFO_EVENTS');
export const readyToFetchInfoEvents = actionCreator('READY_TO_FETCH_INFO_EVENTS');
export const fetchInfoEventsCount = asyncActionCreators('FETCH_INFO_EVENTS_COUNT');
export const getLocations = asyncActionCreators('Messages/GET_LOCATIONS');
export const markAsRead = asyncActionCreators('Messages/MARK_AS_READ');
export const markAllAsRead = asyncActionCreators('Messages/MARK_ALL_AS_READ');



// WEBPACK FOOTER //
// ./src/sagas/infoEvents/actions.js